/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const UsersGroupV2FillIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon isFilled {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path
          d="M8.72875 0.319946C5.86257 0.319946 3.5392 2.6434 3.5392 5.50949C3.5392 8.37557 5.86257 10.699 8.72875 10.699C11.5949 10.699 13.9183 8.37557 13.9183 5.50949C13.9183 2.6434 11.5949 0.319946 8.72875 0.319946Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <path
          d="M17.8104 5.50949C15.6608 5.50949 13.9183 7.25208 13.9183 9.40164C13.9183 11.5513 15.6608 13.2938 17.8104 13.2938C19.9601 13.2938 21.7026 11.5513 21.7026 9.40164C21.7026 7.25208 19.9601 5.50949 17.8104 5.50949Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <path
          d="M17.8104 14.5912C16.8267 14.5912 15.9067 14.8654 15.1231 15.3406C13.7178 13.3205 11.3789 11.9964 8.72875 11.9964C6.5156 11.9964 4.51953 12.9198 3.10298 14.4009C1.8222 15.74 1.12486 17.268 1.01364 22.6639C1.0022 23.2188 1.452 23.6729 2.00703 23.6729H21.7026C22.4191 23.6729 23 23.092 23 22.3755V19.7807C23 16.9146 20.6766 14.5912 17.8104 14.5912Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </svg>
    </Icon>
  );
});

export { UsersGroupV2FillIcon };
